export default __webpack_public_path__ + "static/media/manufacturing.51a166e8.png";